import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-unregvoter',
  templateUrl: './unregvoter.component.html',
  styleUrls: ['./unregvoter.component.css']
})
export class UnregvoterComponent implements OnInit {

  status;
  constructor(
              public router: Router,
              private route: ActivatedRoute,
  	) { }

  ngOnInit(): void {
  	this.route.queryParams.subscribe(params => {
		let value_1 = params['stat'];
		if(value_1 == 'noreg'){
			this.status = 'This mobile number is not registred!';
		}else if(value_1 == 'noact'){
			this.status = 'You have submitted voter registration successfully, it will be approved shortly!';

		}else{
			this.status = 'This is action is not permitted.';
		}
  	});
  }

}
